const QuantitySelector = ({
  quantity,
  onIncrease,
  onDecrease,
  maxWidth = "120px",
}) => {
  return (
    <div
      className="input-group d-flex mx-auto align-items-center quantity-container"
      style={{ maxWidth, flexWrap: "nowrap" }}
    >
      <div className="input-group-prepend">
        <button
          className="btn btn-outline-black decrease"
          type="button"
          onClick={onDecrease}
          disabled={quantity <= 1}
        >
          &minus;
        </button>
      </div>
      <input
        type="text"
        className="form-control text-center quantity-amount"
        style={{ width: "50px" }}
        value={quantity}
        readOnly
        aria-label="Quantity"
      />
      <div className="input-group-append">
        <button
          className="btn btn-outline-black increase"
          type="button"
          onClick={onIncrease}
        >
          &#43;
        </button>
      </div>
    </div>
  );
};

export default QuantitySelector;
